import { render, staticRenderFns } from "./checkModal.vue?vue&type=template&id=468f2e1b&"
import script from "./checkModal.vue?vue&type=script&lang=js&"
export * from "./checkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports